import  { useState, useEffect } from 'react';
import {  useLocation, useSearchParams } from 'react-router-dom'; // Assuming you're using react-router for navigation
import styles from './header.module.css';
import { Menu, IconButton, CircularProgress, Typography, Box, Modal, Button } from '@mui/material';
import { localEndPoint } from './ServerCall/EnvironmentVariables';
import Cookies from 'js-cookie';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { userAuthentication } from '../redux/UserInfo/isLoggedActions';
import FetchData from './ServerCall/FetchData';
import { palette } from '..';
import { DeleteAllCookies } from '../Components/CommonFunctions/CommonFunctions';
import { useSelector } from 'react-redux';
import { RootState } from '../redux';
import { navigatetTo } from './CommonFunctions/aliases';
import Logger from '../Logger';
import UpdateProfileMenuItem from './UpdateProfileMenuItem';
import LogoutMenuItem from './LogoutMenuItem';
import SettingsMenuItem from './SettingsMenuItem';
import { IUserDetails } from '../api/types';
import SupportMenuItem from './TabsAndTiles/SupportMenuItem';
import { truncateEmail } from '../Components/CommonFunctions/CommonFunctions';

const supportModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
  borderRadius: '10px',
  outline: 'none',
  '&:focus': {
    outline: 'none',
  },
};

const Header = (props: any) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const location = useLocation();
  const domain = window.location.hostname.split('.').slice(-2).join('.');

  const showWelcomeMessage = Cookies.get('showWelcomeMessage');

  // State to store user details
  const [user, setUser] = useState(
    props.isLogged.isUserLogged
      ? {
          firstName: props.isLogged.firstName,
          lastName: props.isLogged.lastName,
          email: props.isLogged.email,
          avatar: props.isLogged.avatar,
        }
      : {
          firstName: '',
          lastName: '',
          email: '',
          avatar: '',
        },
  );
  const [loading, setLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(
    () => location.pathname === '/' && showWelcomeMessage === 'true',
  );

  // Removing the show welcome message variable from cookies after the modal is visisble
  useEffect(() => {
    if (!isWelcomeModalOpen) {
      Cookies.remove('showWelcomeMessage', {
        domain: domain,
        path: '/',
      });
    }
  }, [isWelcomeModalOpen]);

  const {
    tabState,
    tileState,
    tabTileProps,
    chartProperties,
    chartControls,
    chartFilterGroup,
    dynamicMeasuresState,
    calculations,
    playBookState,
  } = useSelector((state: RootState) => state);

  const [searchParams] = useSearchParams();
  const workspaceId = searchParams.get('workspaceId');
  const playbookId = searchParams.get('playbookId');
  const isPublicPath = window.location.href.includes('dashboard');
  // Fetch user details from the API
  // useEffect(() => {
  //   const token =localStorage.getItem('accessToken')
  //   const fetchUserDetails = async () => {
  //     try {
  //       const response = await fetch('https://dev.silzila.com/api/user-details', {
  //         method: 'GET',
  //         headers: {
  //           'Content-Type': 'application/json',
  //           // Include authentication headers if required
  //           'Authorization': `Bearer ${token}`,
  //         },
  //       });

  //       if (!response.ok) {
  //         throw new Error(`Error: ${response.status} ${response.statusText}`);
  //       }

  //       const data = await response.json();

  //       // Assuming the API returns data in the following format:
  //       // { name: 'John Doe', email: 'john.doe@example.com', avatar: '/path/to/avatar.png' }
  //       setUser({
  //         firstName: data.firstName || ' ',
  //         lastName: data.lastName||'',
  //         email: data.email || 'N/A',
  //         avatar: data.profileImage && data.profileImage.trim() !== '' ? `data:image/jpeg;base64,${data.profileImage}` : '/default.png',
  //       });
  //       setLoading(false);
  //     } catch (err) {
  //       console.error(err);
  //       setLoading(false);
  //     }
  //   };

  //   fetchUserDetails();
  // }, []);
  const currentPlaybook = () => {
    return {
      tabState,
      tileState,
      tabTileProps,
      chartProperty: chartProperties,
      chartControl: chartControls,
      chartGroup: chartFilterGroup,
      dynamicMeasureState: dynamicMeasuresState,
      calculations,
    };
  };

  useEffect(() => {
    // For Navigating to login page if user is not logged in and token is not present in cookies
    if (
      (!Cookies.get('refreshToken') || sessionStorage.getItem('isLoggingOut') === 'true') &&
      window.location.protocol === 'https:' && // to avoid redirection in dev mode
      !isPublicPath
    ) {
      localStorage.clear();
      localStorage.setItem('isLoggingOut', 'true'); // to prevent default popup coming on navigation
      if (playbookId && workspaceId) {
        localStorage.setItem('playbookId', playbookId);
        localStorage.setItem('workspaceId', workspaceId);
      }
      sessionStorage.removeItem('isLoggingOut');
      DeleteAllCookies();
      Cookies.remove('authToken');
      window.history.pushState(null, '', '/login');
      window.history.replaceState(null, '', '/login');
      window.location.replace(`${localEndPoint}auth/logout`);
      // if (sessionStorage.getItem('accessType') === 'community') {
      //   window.location.replace(`${localEndPoint}auth/logout`);
      // } else {
      //   window.location.replace(`${localEndPoint}auth/logout`);
      // }
    }
  }, []);

  const fetchUserDetails = async (forceFetch = false) => {
    if (!forceFetch && props.isLogged.isUserLogged && props.isLogged.email !== '') return;
    try {
      // Use the FetchData utility to make the request
      setLoading(true);
      const response = await FetchData({
        requestType: 'withData',
        method: 'GET',
        url: 'user-details',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      if (!response.status) {
        throw new Error(`Error: ${response.error || 'Unknown error'}`);
      }

      const data: IUserDetails = response.data;

      // Assuming the API returns data in the following format:
      // { name: 'John Doe', email: 'john.doe@example.com', avatar: '/path/to/avatar.png' }
      setUser({
        firstName: data.firstName || ' ',
        lastName: data.lastName || '',
        email: data.email || 'N/A',
        avatar:
          data.profileImage && data.profileImage.trim() !== ''
            ? `data:image/jpeg;base64,${data.profileImage}`
            : '/default.png',
      });
      props.userAuthentication({
        isUserLogged: true,
        accessToken: props.isLogged.accessToken,
        tokenType: props.isLogged.tokenType,
        access: props.isLogged.access,
        firstName: data.firstName || ' ',
        lastName: data.lastName || '',
        email: data.email || 'N/A',
        avatar:
          data.profileImage && data.profileImage.trim() !== ''
            ? `data:image/jpeg;base64,${data.profileImage}`
            : '/default.png',
        businessType: data.businessType,
      });
    } catch (err) {
      Logger('error', 'Error fetching user details', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTimeout(fetchUserDetails, 2000);
  }, [props.isLogged.email, props.isLogged.isUserLogged]);

  /////// Test in QA if login is working fine
  // useEffect(() => {
  //   if (!location) {
  //     navigate('/');
  //   } else if (location.pathname === '/admin/users') {
  //     fetchUserDetails(true); // Force-fetch details when navigating to /admin/users
  //   }
  // }, [location, navigate]);

  const handleMenuOpen = (event: any) => {
    if (isOpen) {
      handleMenuClose();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <header className={styles.header} style={{ backgroundColor: props.backgroundColor }}>
      <div className={styles.nav}>
        <div>
          <IconButton
            onClick={handleMenuOpen}
            aria-haspopup="true"
            aria-expanded={isOpen ? 'true' : 'false'}
            sx={{
              cursor: 'pointer',
              padding: '0 0.2rem',
              // padding: "0 0.3rem",
              // marginRight: "15px",
              '&:hover': {
                cursor: 'pointer',
              },
            }}
          >
            <img
              src={user.avatar!}
              alt="Admin"
              style={{
                border: '1px solid gray',
                borderRadius: '50%',
                verticalAlign: 'center',
                textAlign: 'center',
                width: '1.625rem',
                height: '1.625rem',
              }}
            />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={isOpen}
            onClose={handleMenuClose}
            PaperProps={{
              style: {
                width: '200px',
                transform: 'translate(10px, 7px)',
                backgroundColor: 'white',
                border: '1px solid transparent',
                color: '#616164',
                fontFamily:
                  'Axiforma ExtraBold,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,sans-serif',
              },
            }}
          >
            <div
              style={{
                height: '100px',
                border: '1px solid transparent',
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
                justifyContent: 'center',
                marginBottom: '0px',
                marginTop: '-8px',
              }}
            >
              {loading ? (
                <CircularProgress
                  color="inherit"
                  sx={{
                    display: 'block',
                    margin: '20px auto',
                    color: '#007BFF',
                    width: '50px !important',
                    height: '50px !important',
                  }}
                />
              ) : error ? (
                <Typography
                  variant="body1"
                  color="error"
                  sx={{
                    textAlign: 'center',
                    fontWeight: 'bold',
                    marginTop: '10px',
                    fontSize: '0.8rem',
                  }}
                >
                  {error}
                </Typography>
              ) : (
                <div>
                  <img
                    src={user.avatar!}
                    alt="Admin"
                    className="adminImage"
                    style={{
                      border: '1px solid gray',
                      borderRadius: '50px',
                      marginBottom: '8px',
                      marginTop: '65px',
                      width: '50px',
                      height: '50px',
                    }}
                  />
                  <div
                    className="header-name-email-container"
                    style={{
                      border: '2px solid transparent',
                      width: '180px',
                      borderRadius: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      marginLeft: '10px',
                      height: '60px',
                      color: palette.primary.contrastText,
                      fontSize: '12px',
                    }}
                  >
                    <div
                      className="user-name"
                      style={{
                        height: '30px',
                        border: '1px solid transparent',
                        marginBottom: '0px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: palette.primary.contrastText,
                        maxWidth: '160px', // adjust as needed
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                      title={user.firstName + ' ' + user.lastName}
                    >
                      {`${user.firstName} ${user.lastName}`}
                    </div>

                    <div
                      style={{
                        height: '30px',
                        border: '1px solid transparent',
                        color: palette.primary.contrastText,
                        maxWidth: '170px',
                        whiteSpace: 'nowrap',
                        fontSize: '10px',
                      }}
                      title={user.email}
                    >
                      {truncateEmail(user.email, 18)}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <UpdateProfileMenuItem
              handleMenuClose={handleMenuClose}
              from={props.from}
              saveAndNavigateTo={props.saveAndNavigateTo}
              navigateToPath={navigatetTo.updateProfile}
            />

            <SettingsMenuItem
              handleMenuClose={handleMenuClose}
              from={props.from}
              saveAndNavigateTo={props.saveAndNavigateTo}
              navigateToPath={navigatetTo.settings}
            />

            <SupportMenuItem
              setIsSupportModalOpen={setIsSupportModalOpen}
              handleMenuClose={handleMenuClose}
            />

            <LogoutMenuItem
              handleMenuClose={handleMenuClose}
              from={props.from}
              saveAndNavigateTo={props.saveAndNavigateTo}
            />
          </Menu>

          <Modal
            open={isSupportModalOpen}
            onClose={() => setIsSupportModalOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={supportModalStyle}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ lineHeight: '1.8' }}
              >
                Please contact us on <b>support@silzila.com</b> for any queries/help/support/bug
                reporting.
              </Typography>
              <Box sx={{ marginTop: '1.2rem' }}>
                <Button
                  variant="contained"
                  sx={{
                    color: '#2bb9bb',
                    border: '1px solid #2bb9bb',
                    backgroundColor: 'transparent',
                    '&:hover': {
                      backgroundColor: 'rgba(43, 185, 187, 0.05)',
                      border: '1px solid #2bb9bb',
                    },
                  }}
                  onClick={() => setIsSupportModalOpen(false)}
                >
                  Ok
                </Button>
              </Box>
            </Box>
          </Modal>

          <Modal
            open={isWelcomeModalOpen}
            onClose={() => setIsWelcomeModalOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={supportModalStyle}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                sx={{ lineHeight: '1.8', textAlign: 'left' }}
              >
                <p style={{ margin: '4px 0' }}>
                  Hello {user.firstName?.charAt(0).toUpperCase() + user.firstName?.slice(1)},
                </p>
                <p style={{ margin: '4px 0' }}>
                  If you want a free demo or any kind of help, please reach out to{' '}
                  <b>support@silzila.com</b>. We are happy to assist.
                </p>
              </Typography>
              <Box
                sx={{
                  marginTop: '1.2rem',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    color: '#2bb9bb',
                    border: '1px solid #2bb9bb',
                    backgroundColor: 'transparent',
                    '&:hover': {
                      backgroundColor: 'rgba(43, 185, 187, 0.05)',
                      border: '1px solid #2bb9bb',
                    },
                  }}
                  onClick={() => setIsWelcomeModalOpen(false)}
                >
                  OK
                </Button>
              </Box>
            </Box>
          </Modal>
        </div>
      </div>
    </header>
  );
};

// Map dispatch to props
const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    userAuthentication: (payload: any) => dispatch(userAuthentication(payload)),
  };
};
const mapStateToProps = (state: any) => {
  return {
    isLogged: state.isLogged,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
